import { render } from "./Footer.vue?vue&type=template&id=69159fcd&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=69159fcd&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69159fcd"]])

export default __exports__